import React from "react";

import { setSelectedDate } from "@/features/systemSlice";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
export default function DateSelection(props) {
  const {
    defaultStartDate = moment().startOf("month"),
    defaultEndDate = moment().endOf("month"),
    md = 6,
    lg = 6,
    xs = 12,
  } = props;
  const location = useLocation();
  const dispatch = useDispatch();
  const { pathname } = location;

  const startDate = useSelector(
    (state) => state.system.selectedDate[pathname]?.startDate
  );
  const endDate = useSelector(
    (state) => state.system.selectedDate[pathname]?.endDate
  );

  React.useEffect(() => {
    if (!startDate || !endDate) {
      dispatch(
        setSelectedDate({
          page: pathname,
          value: {
            startDate: moment(defaultStartDate).format("YYYY-MM-DD"),
            endDate: moment(defaultEndDate).format("YYYY-MM-DD"),
          },
        })
      );
    }
  }, [startDate, endDate]);
  return (
    <>
      <Grid
        size={{
          xs: xs,
          md: md,
          lg: lg
        }}>
        <DatePicker
          label="開始日期"
          maxDate={endDate}
          value={startDate}
          onChange={(newValue) => {
            dispatch(
              setSelectedDate({
                page: pathname,
                value: {
                  startDate: moment(newValue).format("YYYY-MM-DD"),
                  endDate,
                },
              })
            );
          }}
          renderInput={(params) => (
            <TextField {...params} sx={{ width: "100%" }} />
          )}
        />
      </Grid>
      <Grid
        size={{
          xs: xs,
          md: md,
          lg: lg
        }}>
        <DatePicker
          label="結束日期"
          value={endDate}
          onChange={(newValue) => {
            dispatch(
              setSelectedDate({
                page: pathname,
                value: {
                  endDate: moment(newValue).format("YYYY-MM-DD"),
                  startDate,
                },
              })
            );
          }}
          renderInput={(params) => (
            <TextField {...params} sx={{ width: "100%" }} />
          )}
        />
      </Grid>
    </>
  );
}
